export const TIMESERIES_X_EXTENTS = [2009,2025]
export const TIMESERIES_X_EXTENTS_MISSING = [2019,2022]
export const TIMESERIES_Y_EXTENTS = {
	avg: [-6, 6],
	coh: [-2, 2],
	grd: [-2, 2],
	imp: [-2, 2]
}